<template><Login /></template>
<script>
// The password route shows the shared login with the password tab selected.
import Login from './index.vue';
export default { components: { Login } };
</script>
